import { Mark, mergeAttributes } from "@tiptap/react";
const Collaborative = Mark.create({
  name: "collaborative",
  parseHTML: () => {
    return [
      {
        tag: "span",
      },
    ];
  },
  addAttributes() {
    return {
      "data-authorId": {
        parseHTML: (element) => {
          const classList = [];
          for (const cls of element.classList.entries()) {
            // eslint-disable-next-line no-unused-vars
            const [key, value] = cls;
            if (value.includes("a_") || value.includes("anonymous"))
              classList.push(value);
          }
          return classList.length ? classList.join(" ") : null;
        },
      },
      title: {
        parseHTML: (element) => {
          return element.getAttribute("title") ?? null;
        },
      },
    };
  },
  renderHTML: ({ HTMLAttributes }) => {
    return ["span", mergeAttributes(HTMLAttributes)];
  },
});

export default Collaborative;
